
import moment from 'moment'
import { Data, Methods, Computed, Props } from './inputHoraEMinuto.modelo'
import Vue from 'vue'

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'InputHoraEMinuto',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    mensagemDeErro: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      erroValidacaoHorario: ''
    }
  },
  computed: {
    horario: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    converterStringHoraEMinutoParaData (dataReferencia) {
      if (moment(this.horario, 'HH:mm', true).isValid()) {
        const horarioMoment = moment(this.horario, 'HH:mm')
        return moment(dataReferencia)
          .set({
            hour: horarioMoment.hour(),
            minute: horarioMoment.minute(),
            second: 0,
            millisecond: 0
          })
          .toDate()
      }
      return null
    },
    coverterDataParaStringHoraEMinuto (data) {
      return moment(data).format('HH:mm')
    },
    validarHorario () {
      if (!moment(this.horario, 'HH:mm', true).isValid()) {
        this.erroValidacaoHorario = this.$t('comum.inputs.inputHoraEMinuto.horarioInvalido') as string
        return false
      }
      this.erroValidacaoHorario = ''
      return true
    }
  },
  watch: {
    horario (valor) {
      this.validarHorario()
    }
  }
})
